import { BUSCAR_SE_USUARIO_VENDE_ENCOMENDA_COM_CTE } from '../../actions/types'

const estadoInicial = null

export default function reducerUsuarioVendeEncomendaComCte (state = estadoInicial, action) {
  switch (action.type) {
    case BUSCAR_SE_USUARIO_VENDE_ENCOMENDA_COM_CTE: {
      return action.payload.data;
    }
    default: {
      return state
    }
  }
}
